import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {Address} from '../forms';
import {connect} from 'react-redux';
import {updateCard} from 'actions'
class CardForm extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'CardForm';
        this.state = {
        	object : "card",
        	exp_month : null,
        	exp_year : null,
        }

        this.handleAddressChange = this.handleAddressChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleCardNumber = this.handleCardNumber.bind(this);
        this.handleCVCNumber = this.handleCVCNumber.bind(this);
    }
    handleAddressChange(change) {
    	this.props.dispatch(updateCard(change));
    }
    handleChange(change) {
    	var card = this.props.account.card;
    	if(!card)
    		card = {};

	    	change = Object.assign({},card,change);
	    	this.props.dispatch(updateCard(change));

    }
    handleCardNumber(change) {
    	if(!isNaN(Number(change.number)) && change.number.length <= 16)
	    	this.handleChange(change);
    }
    handleCVCNumber(change) {
    	if(!isNaN(Number(change.cvc)) && change.cvc.length <= 4)
	    	this.handleChange(change);
    }
    componentWillMount() {
    	if(!this.props.account.card)
	    	this.props.dispatch(updateCard({
	        	object : "card",
	        	exp_month : null,
	        	exp_year : null,
	    	}))
    }
    componentWillUnmount() {
    	this.props.dispatch(updateCard(null)); //Nothing to see here.
    }
    render() {
    	var card = {}
    	if(this.props.account.card)
    		card = this.props.account.card;
        return (
        	<div className="row">
        		<div className="form-group">
	        		<div className="col-xs-12 mb-sm">
	        			<h3 className="title">Card Details</h3>
		        		<label className="control-label">Name On Card</label>
		        		<input type="text" onChange={({target})=>this.handleChange({name : target.value})} placeholder="First and Last Name" className="form-control" value={card.name} />
	        		</div>
	        		<div className="col-xs-12 mb-sm">
	        			<div className="row">
		        			<div className="col-xs-12 col-md-6">
					    		<label className="control-label">Card Number</label>
				        		<input type="text" onChange={({target})=>this.handleCardNumber({number : target.value })} placeholder="Card Number" className="form-control" value={card.number} />
				        	</div>
			        		<div className="col-xs-12 col-md-6">
				        		<label className="control-label">CVC</label>
			        			<input type="text" onChange={({target})=>this.handleCVCNumber({cvc : target.value })} placeholder="CVC" className="form-control" value={card.cvc} />
			        		</div>
			        	</div>
	        			<div className="row">
		        			<div className="col-xs-6 col-md-6">
	        					<label className="control-label">Month</label>
		        				<select onChange={({target})=>this.handleChange({ exp_month : target.value })} className="form-control" value={card.exp_month}>
		        					<option value={null}>Select One</option>
			        				{(()=>{
			        					var months = [];
			        					for(var i = 1; i <= 12; i++) {
			        						months.push(<option value={i}>{i}</option>)
			        					}
			        					return months;
			        				})()}
		        				</select>
		        			</div>
		        			<div className="col-md-6 col-xs-6">
	        					<label className="control-label">Year</label>
		        				<select onChange={({target})=>this.handleChange({exp_year : target.value})} className="form-control" value={card.exp_year}>

		        					<option value={null}>Select One</option>
			        				{(()=>{
			        					var years = [];
			        					var startYear = Number(moment(new Date()).format('YYYY'));
			        					for(var i = startYear; i < startYear + 20; i++) {
			        						years.push(<option key={i} value={i}>{i}</option>);
			        					}
			        					return years;
			        				})()}
		        				</select>
		        			</div>
		        		</div>
	        		</div>
	        	</div>

	        	<hr className="separator" />

        		<div className="form-group">
        			<div className="col-xs-12">
	        			<h3 className="title">Card Address</h3>
        			</div>
        			<div className="col-xs-12">
	        			<Address address={card} onChange={this.handleAddressChange} />
        			</div>
        		</div>

	        	<hr className="separator" />

	        	<div className="row">
	        		<div className="col-xs-12">
		        		<div className="col-xs-6 col-md-3 col-md-offset-6">
		        			<div onClick={this.props.onCancel} className="btn btn-block btn-default">Cancel</div>
		        		</div>
		        		<div className="col-xs-6 col-md-3">
		        			<div onClick={() => this.props.onSave(this.props.account.card) } className="btn btn-block btn-primary">Save Card</div>
		        		</div>
	        		</div>
	        	</div>

        	</div>
        );
    }
}

var mapStateToProps = ({account}) => {
	return {
		account
	}
}

export default connect(mapStateToProps)(CardForm);



// WEBPACK FOOTER //
// ./src/browser/components/account/cardForm.js